import { render } from "./Snow.vue?vue&type=template&id=3c5cad1f&scoped=true"
const script = {}

import "./Snow.vue?vue&type=style&index=0&id=3c5cad1f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c5cad1f"

export default script